import React, { useEffect, useMemo } from 'react';
import ReactECharts from 'echarts-for-react';
import { EChartsOption } from 'echarts';
import { StackedBarChartProps } from '../types';
import ChartWrapper from '../../../ChartWrapper';

const DEFAULT_STYLE = {
  height: 616,
  width: '100%',
};

function HorizontalStackedBar({
  data,
  left = 120,
  right = 30,
  top = 10,
  bottom = 30,
  bottomLegend = false,
  onLegendSelect = () => {},
}: StackedBarChartProps) {
  const option: EChartsOption = useMemo(() => {
    const result: EChartsOption = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          // Use axis to trigger tooltip
          type: 'shadow', // 'shadow' as default; can also be 'line' or 'shadow'
        },
      },
      legend: bottomLegend
        ? {
            bottom: '18',
            left: 'center',
          }
        : {},
      grid: {
        left,
        right,
        top,
        bottom,
      },
      yAxis: {
        type: 'category',
        data: data.dates,
        axisLabel: {
          formatter: (value: string) => {
            return value.length > 15 ? `${value.slice(0, 15)}...` : value;
          },
          hideOverlap: true,
        },
        tooltip: {
          show: true,
        },
        inverse: true,
        boundaryGap: true,
        axisTick: {
          alignWithLabel: true,
        },
      },
      xAxis: {
        type: 'value',
      },
      series: data.series.map(p => ({
        name: p.name,
        type: 'bar',
        stack: 'total',
        label: {
          show: false,
        },
        barMaxWidth: 30,
        emphasis: {
          focus: 'series',
        },
        data: p.data,
        color: p.color,
      })),
    };

    return result;
  }, [data]);

  const events = useMemo(() => {
    return {
      legendselectchanged: (param: any, echarts: any) => {
        onLegendSelect(param.name);
      },
    };
  }, []);

  return (
    <ChartWrapper>
      <ReactECharts option={option} style={DEFAULT_STYLE} onEvents={events} />
    </ChartWrapper>
  );
}

export default HorizontalStackedBar;
